import dekaaLogo from './Images/dekaa-logo.svg'
import twoRabbits from './Images/two-rabbits.svg'
import shethiya from './Images/shethiya.svg'
import kalyanCare from './Images/kalyan-integrated-cure.svg'

import flowBuilder from './Images/flow-builder.webp'
import campaigns from './Images/campaigns.webp'
import temInboxTab from './Images/team-inbox-tab.webp'

import connectIcon from './Images/connect.svg'
import createIcon from './Images/create.svg'
import automateIcon from './Images/automate.svg'

import fasterResponse from './Images/faster-respone.svg'
import moreConversation from './Images/more-conversation.svg'
import customerEngagement from './Images/customer-engagement.svg'
import temProductivity from './Images/team-productivity.svg'

import healthcare from './Images/healthcare-clinics.svg';
import realEstate from './Images/real-estate.svg'
import ecommerce from './Images/e-commerce.svg'
import finance from './Images/finance-insurance.svg'
import restaurants from './Images/restaurants.svg'
import retailStores from './Images/retail-stores.svg'
import automobile from './Images/automobile-dealers.svg'
import salon from './Images/salon-spas.svg'
import event from './Images/events-webinars.svg'

import freeIcon from "./Images/free-forever.svg";
import starterIcon from "./Images/starter.svg";
import proIcon from "./Images/pro.svg";
import enterpriseIcon from "./Images/enterprise.svg";

import sureshKerai from './Images/suresh-kerai.png'
import arpitPatel from './Images/arpit-patel.webp'
import nirvishaSoni from './Images/nirvisha-soni.png'
import krishnaKangad from './Images/krishna-kangad.png'
import priteshKerai from './Images/pritesh-kerai.png'
import sumitChauhan from './Images/sumit-chauhan.png'
import satyamTrivedi from './Images/satyam-trivedi.webp'


import agentMangement from './Images/agent-management.webp'
import contatCrm from './Images/contact-crm.webp'
import scheduledReminders from './Images/scheduled-reminders.webp'
import broadcasts from './Images/broadcasts.webp'
import whatsappForms from './Images/whatsapp-forms.webp'
import template from './Images/templates.webp'
import flowLibrary from './Images/flow-library.webp'
import productCatalog from './Images/product-catalog.webp'
import apiIntegration from './Images/api-integration.webp'

import whatsappMessage from './Images/whtsp-msg-open-rate.svg'
import leadsLoseIntrest from './Images/leads-lose-intrest.svg'
import instantReplies from './Images/instant-replies.svg'
import helpingBuisnessAutomate from './Images/helping-buisness-automate.svg'

import empowerSmbs from './Images/empower-smbs.svg'
import expandGlobally from './Images/expand-globally.svg'
import scaleAcrossBorders from './Images/scale-across-borders.svg'
import industrySolutions from './Images/industry-solutions.svg'
import growThroughPartners from './Images/grow-through-partners.svg'

import { FiZap, FiMessageSquare, FiHelpCircle, FiCalendar, FiTag, FiTool, FiUsers } from "react-icons/fi";

export const clients=[
    {
        img:dekaaLogo,
        alt:"Dekka"
    },
      {
        img:twoRabbits,
        alt:"Two Rabbits"
    },
      {
        img:shethiya,
        alt:"Shethiya Telecom"
    },
      {
        img:kalyanCare,
        alt:"Kalyan Integrated Care & Research Center"
    }
]

export const stats=[
    {
    id: 1,
    value: 98,
    suffix: "%",
    prefix:"",
    title: "Open Rate",
    desc:"avg WhatsApp message gets read"
  },
  {
    id: 2,
    value: 260,
    suffix: "Cr+",
    prefix:"",
    title: "Global Reach",
    desc:"your customers are already here"
  },
  {
    id: 3,
    value: 74,
    suffix: "%",
    prefix:"",
    title: "Trust Rate",
    desc:"trust messages more than email or social"
  },
  {
    id: 4,
    value: 60,
    suffix: "%",
    prefix:"~",
    title: "Click Rate",
    desc:"vs under 5% for getting clicks on email"
  }
]

export const problemSolutionData = [
  {
    id: 1,
    tab: "Flow Builder",
    image: flowBuilder,
    problem: {
      title: "Problem",
      heading: "Leads go cold when responses go slow.",
      description:
        "A lead messages at 11pm. By the time someone replies next morning, they've already booked with a competitor."
    },
    solution: {
      title: "Solution",
      heading: "Automate. Reply. Convert.",
      description:
        "Build keyword-triggered flows that answer enquiries, qualify leads, and route conversations 24/7, no manual work needed."
    }
  },
  {
    id: 2,
    tab: "Team Inbox",
    image: temInboxTab,
    problem: {
      title: "Problem",
      heading: "Leads Get Lost in the Handoff.",
      description:
        "One number, five people replying. Leads get double-texted, dropped between shifts, or lost in someone’s personal chat."
    },
    solution: {
      title: "Solution",
      heading: "One Inbox. Zero Chaos.",
      description:
        "Assign conversations, track status, and make sure no lead ever falls through the gap — across your entire team."
    }
  },
  {
    id: 3,
    tab: "Campaigns",
    image: campaigns,
    problem: {
      title: "Problem",
      heading: "Manual Messaging Is Slowing Your Growth.",
      description:
        "Messaging your whole list by hand eats an entire day — and you still can’t tell who opened, replied, or ignored it."
    },
    solution: {
      title: "Solution",
      heading: "1,000 Customers. One Send.",
      description:
        "Launch personalized WhatsApp campaigns to your entire contact list in minutes — scheduled, compliant, and tracked in real time."
    }
  },
{
  id: 4,
  tab: "API",
  image: apiIntegration,
  problem: {
    title: "Problem",
    heading: "Your Business Tools Don't Talk to WhatsApp.",
    description:
      "Customer data is scattered across different systems, forcing teams to manually update and share information."
  },
  solution: {
    title: "Solution",
    heading: "Connect Everything. Automate Anything.",
    description:
      "Integrate your CRM, ERP, or custom apps with ONBBITS to sync data and automate conversations in real time."
  }
}
];

export const automateSteps=[
  {
    number:"01",
    icon:connectIcon,
    title:"Connect",
    desc:"Connect your WhatsApp Business API to Onbbits in just a few clicks."
  },
   {
    number:"02",
    icon:createIcon,
    title:"Create",
    desc:"Create targeted campaigns with personalized messages and rich media."
  },
   {
    number:"03",
    icon:automateIcon,
    title:"Automate",
    desc:"Set up automated flows to nurture leads and drive conversions effortlessly."
  }
]

export const comparisonData=[
    {
    id: 1,
    type: "before",
    heading: "The Old Way",
    description:
      "Disjointed. Manual. Inefficient",
    points: [
      "Fragmented tools used for marketing, support, and sales teams.",
      "Manual routing required for repetitive customer query replies.",
      "No CRM sync available for unified client context data tracking.",
      "Developer help constantly needed for every small workflow shift."
    ]
  },
  {
    id: 2,
    type: "after",
    heading: "The New Way",
    description:
      "Unified. Automated. Scalable.",
    points: [
      "One unified workspace managing the entire internal customer journey.",
      "Advanced AI instantly resolves over 80% of routine client inquiries.",
      "Deep, real-time sync perfectly paired with Salesforce & HubSpot.",
      "Visual drag-and-drop builder easily used by anyone on the team."
    ]
  }
]

export const comparisonGrid=[
  {
    icon:fasterResponse,
    title:"80%",
    desc:"Faster Response"
  },
   {
    icon:moreConversation,
    title:"3x",
    desc:"More Conversion"
  },
   {
    icon:customerEngagement,
    title:"24/7",
    desc:"Customer Engagement"
  },
   {
    icon:temProductivity,
    title:"10x",
    desc:"Team Productivity"
  }
]

export const industries=[
  /*{
    icon:education,
    title:"EdTech & Coaching",
    desc:"Enrolment flows"
  },*/
   {
    icon:healthcare,
    title:"Healthcare & Clinics",
    desc:"Appointment reminders"
  },
   {
    icon:realEstate,
    title:"Real Estate",
    desc:"Lead qualification"
  },
   {
    icon:ecommerce,
    title:"E-commerce & D2C",
    desc:"Cart recovery"
  },
   {
    icon:finance,
    title:"Finance & Insurance",
    desc:"Lead nurturing"
  },
   {
    icon:restaurants,
    title:"Restaurants & F&B",
    desc:"Order & reservations"
  },
   {
    icon:retailStores,
    title:"Retail Stores",
    desc:"Offer campaigns"
  },
   {
    icon:automobile,
    title:"Automobile Dealers",
    desc:"Test drive booking"
  },
   {
    icon:salon,
    title:"Salons & Spas",
    desc:"Booking automation"
  },
   {
    icon:event,
    title:"Events & Webinars",
    desc:"Registration flows"
  },
   /*{
    icon:agencies,
    title:"Agencies & Freelance",
    desc:"Client management"
  },
   {
    icon:localService,
    title:"Local Services",
    desc:"Inquiry automation"
  }*/
]

export const testimonials = [
  /*{
    id: 1,
    review:
     "Onbbits completely transformed how we sell. The AI agents qualify leads instantly, and our AE's close them right inside the shared inbox.",
    stat: "40%+",
    statText: "Conversion Increase",
    name: "Sarah Jenkins",
    designation: "VP of Sales, TechFlow",
    stars: 5,
    img:'/Images/sarah-jenkins.png'
  },
  {
    id: 2,
    review:
      "The visual workflow builder let us automate our entire onboarding sequence in an afternoon without involving engineering.",
    stat: "12 hrs+",
    statText: "Saved Weekly",
    name: "Marcus Thorne",
    designation: "Head of Support, Nexus",
    stars: 5,
    img:'/Images/marcus-thorne.png'
  },
  {
    id: 3,
    review:
      "We migrated from a legacy provider & saw immediate improvements. The Salesforce integration is flawless & enterprise made procurement happy.",
    stat: "Up to 3x",
    statText: "Faster Response",
    name: "Emily Carter",
    designation: "Operations Lead, BrightHive",
    stars: 5,
    img:'/Images/emily-carter.png'
  },
  {
  id: 4,
  review:
    "Our response time dropped from hours to minutes after implementing ONBITS. Customers now receive instant replies, while our team handles only high-value conversations.",
  stat: "82%",
  statText: "Faster First Reply",
  name: "Daniel Foster",
  designation: "Customer Manager, ElevateX",
  stars: 5,
  img:'/Images/daniel-foster.png'
},*/
{
  id: 1,
  review:
    "Managing incoming customer leads across channels used to be chaotic. ONBBITS structured our whole process, allowing us to route inquiries instantly and never miss a follow-up.",
  stat: "3.5x",
  statText: "Faster Lead Capture",
  name: "Kalpesh Shethiya",
  designation: "Owner, Shethiya Telecom",
  stars: 5,
  img:'/Images/kalpesh-shethiya.png'
},
{
  id: 2,
  review:
    "Automating our lead pipeline boosted our operational efficiency. Tracking, qualifying, and assigning service requests is now effortless.",
  stat: "50%+",
  statText: "Higher Lead Conversion",
  name: "Ankur Bavarava",
  designation: "Founder, Deeka Fix LLP",
  stars: 5,
  img:'/Images/ankur-bavarava.png'
},
{
  id: 3,
  review:
    "ONBBITS streamlined our store sales and customer chats. Automated product queries to direct purchases made scaling seamless",
  stat: "2.4x",
  statText: "E-Commerce Sales Growth",
  name: "Nitin Vekariya",
  designation: "Founder, The Buzz Brew",
  stars: 5,
  img:'/Images/nitin-vekariya.png'
}
];

export const pricingTabs = [
  "Monthly",
  "Quarterly",
  "Yearly"
];

export const pricingOffer = {
  title: "Founding offer · Ends 15 August",
  heading: (<>Lock in your lowest price — <span>for a whole year</span></>),
  desc:
    "Choose a yearly plan before 15 August 2026 and your rate stays frozen for 12 months — guaranteed.",
  save: "53%",
  price: (<>₹699<span>/mo</span></>),
  oldPrice: "₹1499",
  cta: "Grab The Offer",
  sideText:
    "Start without any cost and scale up operations on your own terms."
};

export const pricingPlans = {

  Monthly: [
 {
      id:1,
      type:"free",
      icon:freeIcon,
      title:"Free Forever",
      subtitle:"Start automating your first conversations at no cost.",
      price:"₹0",
      duration:"/mo",
      note:"No credit card required",
      button:"Get Started Free",
      link:"https://app.onbbits.io/register",
      popular:false,
      features:[
        "Manage conversations with an owner account",
        "Manage up to 50 MB of asset storage",
        "Create up to 3 templates",
        "Up to 3 tags",
        "Basic Support",
        "Live Chat Dashboard"
      ]
    },
    {
      id:2,
      type:"starter",
      icon:starterIcon,
      title:"Starter",
      subtitle:"For small businesses ready to automate WhatsApp.",
      price:"₹1,399",
      duration:"/mo",
      note:(<>Billed monthly <br /> 18% GST will be applicable.<br /><span>Everything in Free, plus —</span></>),
      button:"Get Started",
      link:"https://app.onbbits.io/register",
      popular:false,
      features:[
        "1 Owner + 3 FREE Agents Included",
        "Create up to 100 Templates",
        "Manage Conversations with 50 Tags",
        "Manage up to 1 GB of Asset Storage",
        "Up to 2 Custom Attributes",
        "1 Chat-bot Flow Included",
        "Multi Agent Access",
        "Run Broadcasts Seamlessly",
        "Shared Inbox for Team Collaboration",
        "Plan and Automate your Campaigns",
        "Get Analytics, Reporting & Conversion Insights",
        "CSV Campaign Scheduler",
        "Priority Ticket-based Assistance",
        "Seamless API Access",
        "Launch API requests 250 per minute",
        "Create and use 1 WhatsApp form",
        "Draft your template content using AI (up to 25 generations included)",
        "Schedule up to 5 reminder messages per day"
      ]
    },
    {
      id:3,
      type:"pro",
      icon:proIcon,
      title:"Pro",
      subtitle:"For growing teams that need full automation at scale.",
      price:"₹3,499",
      duration:"/mo",
      note:(<>Billed monthly<br /> 18% GST will be applicable.<br /><span>Everything in Starter, plus —</span></>),
      button:"Choose Pro",
      link:"https://app.onbbits.io/register",
      popular:true,
      features:[
        "1 Owner + 20 FREE Agents Included",
        "Create up to 1000 Templates",
        "Manage Conversations with 200 Tags",
        "Manage up to 5 GB of Asset Storage",
        "Smart Segmentation with 15 Custom Attributes",
        "5 Chat-bot Flow Available",
        "Agent Transfer & Manager Monitoring",
        "Seamless API Access",
        "Launch API requests 500 per minute",
        "Faster Response Support Assistant",
        "Create and use 20 WhatsApp forms.",
        "Create up to 25 audience segments.",
        'Draft your template content using AI (up to 100 generations included)',
        'Schedule up to 50 reminder messages per day',
        "Create product Templates",
        "Design carousel(swipeable) messages",
        "Manage products, catalogs, and Orders"
      ]
    },
    {
      id:4,
      type:"enterprise",
      icon:enterpriseIcon,
      title:"Enterprise",
      subtitle:"For agencies and large teams with custom requirements.",
      price:"Let's Talk",
      duration:"",
      note:(<>Annual contract · volume pricing<br /> 18% GST will be applicable.<br /><span>Everything in Pro, plus —</span></>),
      button:"Talk To Our Team",
      link:"/contact-us",
      popular:false,
      features:[
        "Scale Effortlessly with Flexible Team Sizes",
        "Unlock Custom Templates, Tags & Attributes",
        "Tailored Storage Capacity",
        "Automate Campaigns and Retarget Customers.",
        "Dedicated and Premium Support.",
        "Custom Chatbot Flow Limits",
        "Custom API Limits Tailored for High Volume Campaigns."
      ]
    }
  ],
  Quarterly:[
 {
      id:1,
      type:"free",
      icon:freeIcon,
      title:"Free Forever",
      subtitle:"Start automating your first conversations at no cost.",
      price:"₹0",
      duration:"/mo",
      note:"No credit card required",
      button:"Get Started Free",
      link:"https://app.onbbits.io/register",
      popular:false,
     features:[
        "Manage conversations with an owner account",
        "Manage up to 50 MB of asset storage",
        "Create up to 3 templates",
        "Up to 3 tags",
        "Basic Support",
        "Live Chat Dashboard"
      ]
    },
    {
      id:2,
      type:"starter",
      icon:starterIcon,
      title:"Starter",
      subtitle:"For small businesses ready to automate WhatsApp.",
      price:"₹1,299",
      duration:"/mo",
      note:(<>Billed ₹3,897 · save 7.15%<br /> 18% GST will be applicable.<br /><span>Everything in Free, plus —</span></>),
      button:"Get Started",
      link:"https://app.onbbits.io/register",
      popular:false,
      features:[
        "1 Owner + 3 FREE Agents Included",
        "Create up to 100 Templates",
        "Manage Conversations with 50 Tags",
        "Manage up to 1 GB of Asset Storage",
        "Up to 2 Custom Attributes",
        "1 Chat-bot Flow Included",
        "Multi Agent Access",
        "Run Broadcasts Seamlessly",
        "Shared Inbox for Team Collaboration",
        "Plan and Automate your Campaigns",
        "Get Analytics, Reporting & Conversion Insights",
        "CSV Campaign Scheduler",
        "Priority Ticket-based Assistance",
        "Seamless API Access",
        "Launch API requests 250 per minute",
        "Create and use 1 WhatsApp form",
        "Draft your template content using AI (up to 25 generations included)",
        "Schedule up to 5 reminder messages per day"
      ]
    },
    {
      id:3,
      type:"pro",
      icon:proIcon,
      title:"Pro",
      subtitle:"For growing teams that need full automation at scale.",
      price:"₹3,249",
      duration:"/mo",
      note:(<>Billed ₹9,747· save 7.14%<br /> 18% GST will be applicable.<br /><span>Everything in Starter, plus —</span></>),
      button:"Choose Pro",
      link:"https://app.onbbits.io/register",
      popular:true,
      features:[
        "1 Owner + 20 FREE Agents Included",
        "Create up to 1000 Templates",
        "Manage Conversations with 200 Tags",
        "Manage up to 5 GB of Asset Storage",
        "Smart Segmentation with 15 Custom Attributes",
        "5 Chat-bot Flow Available",
        "Agent Transfer & Manager Monitoring",
        "Seamless API Access",
        "Launch API requests 500 per minute",
        "Faster Response Support Assistant",
        "Create and use 20 WhatsApp forms.",
        "Create up to 25 audience segments.",
        'Draft your template content using AI (up to 100 generations included)',
        'Schedule up to 50 reminder messages per day',
        "Create product Templates",
        "Design carousel(swipeable) messages",
        "Manage products, catalogs, and Orders"
      ]
    },
    {
      id:4,
      type:"enterprise",
      icon:enterpriseIcon,
      title:"Enterprise",
      subtitle:"For agencies and large teams with custom requirements.",
      price:"Let's Talk",
      duration:"",
      note:(<>Annual contract · volume pricing<br /> 18% GST will be applicable.<br /><span>Everything in Pro, plus —</span></>),
      button:"Talk To Our Team",
      link:"/contact-us",
      popular:false,
     features:[
        "Scale Effortlessly with Flexible Team Sizes",
        "Unlock Custom Templates, Tags & Attributes",
        "Tailored Storage Capacity",
        "Automate Campaigns and Retarget Customers.",
        "Dedicated and Premium Support.",
        "Custom Chatbot Flow Limits",
        "Custom API Limits Tailored for High Volume Campaigns."
      ]
    }
  ],
  Yearly:[
    {
      id:1,
      type:"free",
      icon:freeIcon,
      title:"Free Forever",
      subtitle:"Start automating your first conversations at no cost.",
      price:"₹0",
      duration:"/mo",
      note:"No credit card required",
      button:"Get Started Free",
      link:"https://app.onbbits.io/register",
      popular:false,
     features:[
        "Manage conversations with an owner account",
        "Manage up to 50 MB of asset storage",
        "Create up to 3 templates",
        "Up to 3 tags",
        "Basic Support",
        "Live Chat Dashboard"
      ]
    },
    {
      id:2,
      type:"starter",
      icon:starterIcon,
      title:"Starter",
      subtitle:"For small businesses ready to automate WhatsApp.",
      price:"₹1,199",
      duration:"/mo",
      note:(<>Billed ₹14,388 yearly · save 14.30%<br /> 18% GST will be applicable.<br /><span>Everything in Free, plus —</span></>),
      button:"Get Started",
      link:"https://app.onbbits.io/register",
      popular:false,
     features:[
        "1 Owner + 3 FREE Agents Included",
        "Create up to 100 Templates",
        "Manage Conversations with 50 Tags",
        "Manage up to 1 GB of Asset Storage",
        "Up to 2 Custom Attributes",
        "1 Chat-bot Flow Included",
        "Multi Agent Access",
        "Run Broadcasts Seamlessly",
        "Shared Inbox for Team Collaboration",
        "Plan and Automate your Campaigns",
        "Get Analytics, Reporting & Conversion Insights",
        "CSV Campaign Scheduler",
        "Priority Ticket-based Assistance",
        "Seamless API Access",
        "Launch API requests 250 per minute",
        "Create and use 1 WhatsApp form",
        "Draft your template content using AI (up to 25 generations included)",
        "Schedule up to 5 reminder messages per day"
      ]
    },
    {
      id:3,
      type:"pro",
      icon:proIcon,
      title:"Pro",
      subtitle:"For growing teams that need full automation at scale.",
      price:"₹2,999",
      duration:"/mo",
      note:(<>Billed ₹35,988 yearly · save 14.29%<br /> 18% GST will be applicable.<br /><span>Everything in Starter, plus —</span></>),
      button:"Choose Pro",
      link:"https://app.onbbits.io/register",
      popular:true,
      features:[
        "1 Owner + 20 FREE Agents Included",
        "Create up to 1000 Templates",
        "Manage Conversations with 200 Tags",
        "Manage up to 5 GB of Asset Storage",
        "Smart Segmentation with 15 Custom Attributes",
        "5 Chat-bot Flow Available",
        "Agent Transfer & Manager Monitoring",
        "Seamless API Access",
        "Launch API requests 500 per minute",
        "Faster Response Support Assistant",
        "Create and use 20 WhatsApp forms.",
        "Create up to 25 audience segments.",
        'Draft your template content using AI (up to 100 generations included)',
        'Schedule up to 50 reminder messages per day',
        "Create product Templates",
        "Design carousel(swipeable) messages",
        "Manage products, catalogs, and Orders"
      ]
    },
    {
      id:4,
      type:"enterprise",
      icon:enterpriseIcon,
      title:"Enterprise",
      subtitle:"For agencies and large teams with custom requirements.",
      price:"Let's Talk",
      duration:"",
      note:(<>Annual contract · volume pricing<br /> 18% GST will be applicable.<br /><span>Everything in Pro, plus —</span></>),
      button:"Talk To Our Team",
      link:"/contact-us",
      popular:false,
     features:[
        "Scale Effortlessly with Flexible Team Sizes",
        "Unlock Custom Templates, Tags & Attributes",
        "Tailored Storage Capacity",
        "Automate Campaigns and Retarget Customers.",
        "Dedicated and Premium Support.",
        "Custom Chatbot Flow Limits",
        "Custom API Limits Tailored for High Volume Campaigns."
      ]
    }
  ]
};

export const faqs=[
  {
    question:"Is Onbbits on official WhatsApp Business API?",
    answer:"Yes. Onbbits runs entirely on the official WhatsApp Business API as a verified Meta Tech Provider. That means a green-tick verified number, full policy compliance, and reliable delivery at scale — never an unofficial workaround that risks your number getting blocked."
  },
   {
    question:"How many team members can I add?",
    answer:"It depends on your plan. Starter includes one owner plus three agents, while Pro supports one owner plus twenty agents. Everyone shares one inbox, so no chat is missed and assignments stay clear across your whole team."
  },
      {
    question:"What is the difference between the Starter and Pro plan?",
    answer:"Starter suits small teams beginning to automate, offering up to one chatbot flow, three agents, and core campaigns. Pro adds support for up to 20 agents, five flows with API nodes, WhatsApp Forms, audience segments, and enhanced AI—built for businesses scaling serious volume."
  },
   {
    question:"Can I send bulk messages to thousands of contacts?",
    answer:"Yes. Send broadcast campaigns to thousands of opted-in contacts using approved message templates. You’ll see delivery, open and reply rates for every campaign in real time, so you always know exactly how each send performed."
  },
   {
    question:"Can I integrate with WooCommerce?",
    answer:"Yes. Onbbits connects with WooCommerce and other tools to trigger cart-recovery messages, order updates and confirmations automatically. API nodes also pull live data into a conversation, so replies always reflect the latest information."
  },
   {
    question:"What if a customer wants to talk to a human?",
    answer:"Anytime. Your team can jump into any conversation from the shared inbox using “Intervene,” instantly taking over from automation. The customer never notices a handoff — they simply keep chatting in the same familiar WhatsApp thread."
  },
   {
    question:"How do payments and wallet recharges work?",
    answer:"Your plan is billed monthly or annually. Meta’s per-message conversation fees are separate and run from a prepaid wallet you top up as needed. We’ll walk you through exactly what to expect on your demo call — no hidden charges."
  },
   {
    question:"Is my customer data safe with Onbbits?",
    answer:"Yes. Your data is encrypted, stored securely, and used only to power your conversations and analytics — never sold or shared. As an official Meta partner, we follow WhatsApp’s strict privacy and security requirements at every step."
  },
   {
    question:"Is there a free plan?",
    answer:"Yes. Our Free Forever plan lets you get started with no credit card and no time limit — one number and a shared inbox. On your demo call we help you build that flow live, so you see real results before you ever upgrade."
  },
    {
    question:"Do I need coding skills to use the automation?",
    answer:"No coding at all. You build flows by dragging and connecting blocks, and on your free demo call we set up your very first automation live with you. If you can use WhatsApp, you can run Onbbits confidently."
  },
]

export const footerLinks = {
  company: [
    {
      title: "About us",
      link: "/about-us"
    },
    {
      title: "Pricing",
      link: "/pricing"
    },
    {
      title: "Features",
      link: "/features"
    },
      {
      title: "Industries",
      link: "/industries"
    },
    {
      title: "Contact Sales",
      link: "/contact-us"
    }
  ],

  resources: [
    {
      title: "API Reference",
      link:"https://help.onbbits.io/onbbits-api-overview/"
    },
    {
      title: "Case Studies",
    },
    {
      title: "Help Center",
      link: "https://help.onbbits.io/"
    },
       {
      title: "Blog",
      link: "/blog"
    },
  ],

  legal: [
    {
      title: "Privacy Policy",
      link: "/privacy-policy"
    },
    {
      title: "Terms & Conditions",
      link: "/terms-conditions"
    },
    {
      title: "Cancellation & Refund",
      link: "/cancellation-refund"
    },
    {
      title: "Cookie Policy",
      link: "/cookie-policy"
    },
    {
      title: "Sitemap",
      link: "/sitemap"
    },
  ]
};

export const contactInfo = [
  {
    type: "email",
    value: "info@onbbits.io"
  },
  {
    type: "phone",
    value: "+91 97270 77732"
  },
  {
    type: "location",
    value:
      "912, International Finance Center, VIP Road, Vesu, Surat, Gujarat 395007"
  }
];

export const scaleCustomerCommunication=[
  {
    number:"01",
    icon:empowerSmbs,
    title:"Empower SMBs",
    desc:"Make WhatsApp automation simple, affordable, and accessible for SMBs and MSMEs—no technical expertise required."
  },
   {
    number:"02",
    icon:expandGlobally,
    title:"Expand Globally",
    desc:"Build a scalable platform that helps businesses automate customer communication across industries and regions."
  },
   {
    number:"03",
    icon:scaleAcrossBorders,
    title:"Scale Across Borders",
    desc:"Enable businesses to engage customers seamlessly and grow confidently across countries and markets."
  },
    {
    number:"04",
    icon:industrySolutions,
    title:"Industry Solutions",
    desc:"Create tailored automation for e-commerce, healthcare, real estate, and other fast-growing industries."
  },
   {
    number:"05",
    icon:growThroughPartners,
    title:"Grow Through Partners",
    desc:"Help agencies and B2B partners deliver powerful WhatsApp automation solutions to their clients."
  }
]

export const team=[
  {
    img:sureshKerai,
    name:"Suresh Kerai",
    designation:"Co-Founder & CTO / The Tech Visionary",
    desc:"Suresh turns innovation into infrastructure. The driving force behind ONBBITS’ technology, he transforms ambitious ideas into powerful, scalable systems that push the boundaries of what WhatsApp automation can do."
  },
   {
    img:arpitPatel,
    name:"Arpit Patel",
    designation:"Co-Founder & CEO / The Growth Architect",
    desc:"Arpit drives ONBBITS with a vision to turn WhatsApp into a true growth engine. A strategist at heart, he blends marketing, technology, and execution to build tools that deliver measurable business impact"
  },
   {
    img:nirvishaSoni,
    name:"Nirvisha Soni",
    designation:"Head of Product / The Builder of Brilliant Systems",
    desc:"Leading the product and development squad, Nirvisha ensures every feature is functional, intuitive, and delivered with precision. She keeps innovation structured, seamless, and always user-first."
  },
   {
    img:krishnaKangad,
    name:"Krishna Kangad",
    designation:"Backend Engineer / The Systems Connector",
    desc:"Krishna builds the bridges between logic, data, and performance. Her backend mastery keeps every workflow in sync and the ONBBITS engine running flawlessly."
  },
   {
    img:priteshKerai,
    name:"Pritesh Kerai",
    designation:"Full Stack Engineer / The Code Craftsman",
    desc:"Pritesh transforms ideas into efficient, scalable code. Passionate about performance and simplicity, he creates user experiences that feel effortless and refined."
  },
   {
    img:sumitChauhan,
    name:"Sumit Chauhan",
    designation:"Full Stack Engineer / The Innovation Enforcer",
    desc:"Sumit thrives on building smarter. Constantly experimenting, he brings agility, creativity, and fresh thinking to every ONBBITS release."
  },
   {
    img:satyamTrivedi,
    name:"Satyam Trivedi",
    designation:"Creative Consultant / The Brand Storyteller",
    desc:"Satyam gives ONBBITS its voice and visual identity. He turns complex ideas into striking visuals and stories that connect with businesses and inspire growth."
  }
]

export const featurePageData = [
  {
    id: 1,
    subheading: "Flow Builder",
    heading: "Build a conversation that runs itself — no developer required",
    desc: "Drag nodes, connect them with conditions, and define exactly how each conversation goes. A keyword triggers the flow; the customer replies; the flow branches. Your team only sees the chats that need a human.",
    image: flowBuilder,
    points: [
      "Lead-qualification flows that route hot leads to sales",
      "Appointment booking that collects date, time & preference",
      "API Node pulls live data mid-conversation"
    ],
  },
  {
    id: 2,
    subheading: "Agent Management",
    heading: "Give every team member the access they need — and nothing they don’t",
    desc: "Create roles, set permissions, add agents. Sales doesn’t need billing; support doesn’t manage flows; nobody deletes a template by accident. Fine-grained control over exactly what each role can do.",
    image: agentMangement,
    points: [
      "Role-based permissions per view, create, edit & delete",
      "Separate login credentials for every agent",
      "Restrict billing, API & exports to admins only"
    ],
  },
   {
    id: 3,
    subheading: "Contact CRM",
    heading: "Know who your customers are — and every conversation you’ve had",
    desc: "Every contact is captured automatically. Their profile holds conversations, campaigns received, forms filled, tags and custom attributes. No spreadsheet, no separate CRM tool.",
    image: contatCrm,
    points: [
      "Automatic capture from every incoming chat",
      "Custom tags & structured attributes",
      "Full history: conversations, campaigns & forms in one profile"
    ],
  },
  {
    id: 4,
    subheading: "Scheduled Reminders",
    heading: "Send the right message at exactly the right moment — automatically",
    desc: "Set the message and the exact date and time once, right from a contact's chat. Onbbits sends it automatically. No task list, no alarm, no missed follow-up.",
    image: scheduledReminders,
    points: [
      "Schedule any message for a specific date & time",
      "Set it directly from the live chat — no extra setup",
      "Perfect for reminders, payment nudges & renewals"
    ],
  },
   {
    id: 5,
    subheading: "Broadcasts",
    heading: "One click. Thousands of customers. Real results.",
    desc: "Reach your entire list, or a precise segment, in one scheduled send. Every broadcast uses a Meta-approved template, so messages get delivered — not filtered as spam.",
    image: broadcasts,
    points: [
      "Personalised variables — name, product, date — at scale",
      "Real-time delivery, read & reply tracking",
      "Smart opt-out & error filters built in"
    ],
  },
  {
    id: 6,
    subheading: "Team Inbox",
    heading: "Every customer conversation, in one place — for the whole team",
    desc: "Every message lands in a single inbox. Your team works from one screen. Conversations are assigned, tracked and closed — with a full history anyone can see.",
    image: temInboxTab,
    points: [
      "Assign chats by availability or expertise",
      "Internal comments & @mentions only your team sees",
      "Filter & search by status, agent, contact or keyword"
    ],
  },
   {
    id: 7,
    subheading: "WhatsApp Forms",
    heading: "Collect customer information — without sending them elsewhere.",
    desc: "Customers fill the form inside the same conversation — no switching apps, no browser. Responses come back structured and store automatically in the contact’s profile.",
    image: whatsappForms,
    points: [
      "Text fields, dropdowns, date pickers & choices",
      "Embed as a step inside any automation flow",
      "Far higher completion than external form links"
    ],
  },
  {
    id: 8,
    subheading: "Templates",
    heading: "Get your templates approved faster — and write better ones",
    desc: "Create templates with text, media headers and CTA buttons. Submit for Meta review and track status inside Onbbits. The AI Assistant flags likely rejections and refines tone before you submit.",
    image:template,
    points: [
      "Manage every template in one place",
      "AI suggests content & flags rejection triggers",
      "Template Library of industry-specific starters"
    ],
  },
   {
    id: 9,
    subheading: "Flow Library",
    heading: "Your first automation should not start with a blank canvas",
    desc: "Pre-built, industry-specific flows ready to use — or customise in minutes. Booking flows for clinics, enquiry handlers for real estate, qualification flows for coaching. Pick, adjust, go live.",
    image: flowLibrary,
    points: [
      "Pre-built flows across retail, healthcare, education & more",
      "Fully customisable — every message & branch",
      "Cuts setup from hours to minutes"
    ],
  },
  {
    id: 10,
    subheading: "Product Catalog",
    heading: "Your entire product range — inside the WhatsApp conversation",
    desc: "Customers browse products, check prices and enquire without leaving WhatsApp. Powered by a WooCommerce sync, your catalogue stays current automatically — no manual edits.",
    image: productCatalog,
    points: [
      "Share your full catalogue or single items in chat",
      "Live WooCommerce sync — prices & stock auto-update",
      "Send catalog items from a flow or the inbox"
    ],
  },
  {
    id: 11,
    subheading: "API & Integrations",
    heading: "Connect Onbbits to the systems your business already runs on",
    desc: "Onbbits doesn’t replace your tools — it connects to them. Build a two-way connection between WhatsApp automation and your CRM, ERP or booking platform. The API Node checks live data mid-conversation.",
    image: apiIntegration,
    points: [
      "Trigger messages from any system via REST API",
      "Receive incoming messages as webhooks",
      "API Node calls external endpoints inside a flow"
    ],
  },
];

export const chooseYourIndustry=[
  {
    icon:whatsappMessage,
    prefix:"",
    number:98,
    suffix:"%",
    desc:"Average WhatsApp Message Open Rate"
  },
   {
    icon:leadsLoseIntrest,
    prefix:">",
    number:70,
    suffix:"%",
    desc:"Leads Lose Interest After 10 Minutes"
  },
   {
    icon:instantReplies,
    prefix:"",
    number:21,
    suffix:"x",
    desc:"Instant Replies Generate More Qualified Conversions"
  },
   {
    icon:helpingBuisnessAutomate,
    prefix:"",
    number:50,
    suffix:"K +",
    desc:"Helping Businesses Automate Customer Conversations"
  }
]

export const comparisonTable = [
  {
    id: 1,
    title: "Team & Collaboration",
    open: true, 
    rows: [
      {
        feature: "Whatsapp Setup",
        values: ["check", "check", "check"],
      },
      {
        feature: "Agent",
        values: ["-", "Owner + 3 Agents", "Owner + 20 Agents"],
      },
      {
        feature: "Priority Support",
        values: ["-", "By Ticket", "On Priority"],
      },
      {
        feature: "Opt-in Management",
        values: ["-", "check", "check"],
      },
      {
        feature: "Auto Response",
        values: ["check", "check", "check"],
      },
      {
        feature: "Agent Roles",
        values: ["-", "check", "check"],
      },
        {
        feature: "Agent Permissions",
        values: ["-", "check", "check"],
      },
    ],
  },
  {
    id: 2,
    title: "Customer Management",

    rows: [
      {
        feature: "Tag",
        values: ["check", "50 Tags", "200 Tags"],
      },
      {
        feature: "Customer Attributes",
        values: ["check", "2 Attributes", "15 Attributes"],
      },
      {
        feature: "Smart Audience Segregation",
        values: ["-", "-", "25 Segments"],
      },
      {
        feature: "Import Contacts via CSV & Google Sheets",
        values: ["check", "check", "check"],
      },
    ],
  },
  {
    id: 3,
    title: "Messaging & Campaigns",

    rows: [
      {
        feature: "Live Chat Dashboard",
        values: ["check", "check", "check"],
      },
      {
        feature: "Smart Campaign Manager",
        values: ["-", "check", "check"],
      },
      {
        feature: "Message Template",
        values: ["check", "100 Templates", "1000 Templates"],
      },
      {
        feature: "Carousel Template",
        values: ["-", "-", "check"],
      },
      {
        feature: "Campaign Scheduler",
        values: ["-", "check", "check"],
      },
       {
        feature: "Automated Reminders",
        values: ["-", "5 per day", "50 per day"],
      },
      {
        feature: "Analytics & Report",
        values: ["-", "check", "check"],
      },
      {
        feature: "Campaigns Retarget",
        values: ["-", "check", "check"],
      },
      {
        feature: "Template Library",
        values: ["check", "check", "check"],
      },
      {
        feature: "Flow Library",
        values: ["-", "check", "check"],
      },
       {
        feature: "Automatic Failed Message Retry",
        values: ["-", "check", "check"],
      },
    ],
  },
  {
    id: 4,
    title: "Automation & Forms",
    rows: [
      {
        feature: "Chatbot Flow",
        values: ["-", "1", "5"],
      },
       {
        feature: "Whatsapp Forms",
        values: ["-", "1", "20"],
      },
       {
        feature: "Set Tag Node",
        values: ["-", "check", "check"],
      },
      {
        feature: "Condition Node",
        values: ["-", "check", "check"],
      },
      {
        feature: "Location Node",
        values: ["-", "check", "check"],
      },
       {
        feature: "Assign Agent Node",
        values: ["-", "check", "check"],
      },
    ],
  },
  {
    id: 5,
    title: "Commerce & Payments",
    rows: [
      {
        feature: "Razorpay",
        values: ["-", "-", "check"],
      },
       {
        feature: "Whatsapp Commerce",
        values: ["-", "-", "check"],
      },
       {
        feature: "Whatsapp Catalog",
        values: ["-", "-", "check"],
      },
      {
        feature: "Abandon Cart Recovery",
        values: ["-", "-", "check"],
      },
      {
        feature: "Whatsapp Payments Integration",
        values: ["-", "-", "check"],
      },
      {
        feature: "WooCommerce",
        values: ["-", "-", "check"],
      },
      {
        feature: "ERPNext",
        values: ["-", "-", "check"],
      },
    ],
  },
  {
    id: 6,
    title: "Developer Tools",
    rows: [
      {
        feature: "API Access",
        values: ["-", "check", "check"],
      },
       {
        feature: "Whatsapp From Webhook",
        values: ["-", "check", "check"],
      },
       {
        feature: "Whatsapp From API Call",
        values: ["-", "check", "check"],
      },
       {
        feature: "Chatbot API Node",
        values: ["-", "check", "check"],
      },
    ],
  },
  {
    id: 7,
    title: "Storage & AI",
    rows: [
      {
        feature: "Storage",
        values: ["50 MB", "1 GB", "5 GB"],
      },
       {
        feature: "AI Template",
        values: ["-", "25 Per Month", "200 Per Month"],
      },
    ],
  },
  {
    id: 8,
    title: "Onbbits CRM",
    rows: [
      {
        feature: "Lead Management",
        values: ["-", "-", "check"],
      },
      {
        feature: "Pipeline Management & Assignment",
        values: ["-", "-", "check"],
      },
      {
        feature: "Kanban Board",
        values: ["-", "-", "check"],
      },
    ],
  },
];

export const contactCards = [
  {
    icon: FiZap,
    title: "Book a live demo",
    desc: "30-minute walkthrough with our product team. See ONBBITS in action for your industry.",
    link: "Book a Demo",
    url: "/book-a-demo",
    type: "internal",
  },
  {
    icon: FiMessageSquare,
    title: "Chat with sales",
    desc: "Talk to us on WhatsApp. We're available Mon–Sat, 9am to 7pm IST.",
    link: "Chat on WhatsApp",
    url: `https://wa.me/919727077732?text=${encodeURIComponent(
      "Hi ONBBITS Team,\n\nI'm interested in learning more about your WhatsApp automation platform. Could you please assist me?"
    )}`,
    type: "external",
  },
];

export const enquiryTypes = [
  {
    icon: FiMessageSquare,
    label: "General Enquiry",
    value: "General Enquiry"
  },
  {
    icon: FiCalendar,
    label: "Book a Demo",
    value: "Book a Demo"
  },
  {
    icon: FiTag,
    label: "Sales & Pricing",
    value: "Sales & Pricing"
  },
  {
    icon: FiTool,
    label: "Technical Support",
    value: "Technical Support"
  },
  {
    icon: FiUsers,
    label: "Partnership",
    value: "Partnership"
  },
  {
    icon: FiHelpCircle,
    label: "Other Reasons",
    value: "Other Reasons"
  }
];

export const industryDetails=[
  /*{
    id: 1,
    icon: education,
    title: "EdTech & Coaching",
    flow: "Enrollment Flows",
    subText: "Fill every batch. Collect every fee.",
    stats: [
      {
        prefix: "",
        value: 2.5,
        suffix: "×",
        label: "More enrollments",
      },
      {
        prefix: "",
        value: 21,
        suffix: "×",
        label: "Faster lead qualification",
      },
      {
        prefix: "",
        value: 85,
        suffix: "%",
        label: "On-time fee collection",
      },
    ],
    problem:
      "Coaching institutes receive hundreds of WhatsApp enquiries monthly, but delayed responses, inconsistent follow-ups, and manual processes result in missed enrolment opportunities.",
    impacts: [
      {
        title: "More Enrollments",
        value: "2.5×",
      },
      {
        title: "Faster Lead Qualifications",
        value: "21×",
      },
      {
        title: "On-time Fee Collection",
        value: "85%",
      },
    ],
  },*/
   {
    id: 1,
    icon: healthcare,
    title: "Healthcare & Clinics",
    flow: "Appointment reminders",
    subText: "Book every patient. Reduce every no-show.",
    stats: [
      {
        prefix: "",
        value: 30,
        suffix: "%",
        label: "Of patients miss slots",
      },
      {
        prefix: "",
        value: 50,
        suffix: "%",
        label: "Fewer no shows",
      },
      {
        prefix: "",
        value: 82,
        suffix: "%",
        label: "Prefer whatsapp updates",
      },
    ],
    problem:
      "Healthcare staff waste valuable hours on appointment reminders, patient intake, and follow-ups, reducing efficiency, delaying care, and increasing administrative workload.",
    impacts: [
      {
        title: "Patients Miss Slots",
        value: "30%",
      },
      {
        title: "Fewer No Shows",
        value: "50%",
      },
      {
        title: "Prefer Whatsapp Updates",
        value: "82%",
      },
    ],
  },
   {
    id: 2,
    icon: realEstate,
    title: "Real Estate",
    flow: "Lead Qualification",
    subText: "Capture every lead. Close every deal.",
    stats: [
      {
        prefix: "",
        value: 70,
        suffix: "%",
        label: "Intrest drop after 10 mins",
      },
      {
        prefix: "",
        value: 3,
        suffix: "x",
        label: "Higher site visit conversion",
      },
      {
        prefix: "",
        value: 65,
        suffix: "%",
        label: "Enquiries on whatsapp",
      },
    ],
    problem:
      "Real estate businesses lose potential buyers when delayed responses during critical decision windows lead to missed opportunities, lower conversions, and longer sales cycles.",
    impacts: [
      {
        title: "Intrest Drop After 10 Mins",
        value: "70%",
      },
      {
        title: "Higher Site Visit Conversion",
        value: "3x",
      },
      {
        title: "Enquiries on Whatsapp",
        value: "65%",
      },
    ],
  },
   {
    id: 3,
    icon: ecommerce,
    title: "E-commerce & D2C",
    flow: "Lead Qualification",
    subText: "Recover every cart. Increase every order.",
    stats: [
      {
        prefix: "",
        value: 83,
        suffix: "%",
        label: "Of peak order from new buyers",
      },
      {
        prefix: "",
        value: 2.25,
        suffix: "x",
        label: "Higher revenue growth",
      },
      {
        prefix: "",
        value: 11.12,
        suffix: "%",
        label: "Avg journey click through",
      },
    ],
    problem:
      "Brands miss revenue by using WhatsApp only for broadcasts instead of automation, losing conversions through abandoned carts, delayed follow-ups, and weak customer retention.",
    impacts: [
      {
        title: "Order from New Buyers",
        value: "83%",
      },
      {
        title: "Higher Revenue Growth",
        value: "2.5x",
      },
      {
        title: "Avg. Click Through",
        value: "11.12%",
      },
    ],
  },
   {
    id: 4,
    icon: finance,
    title: "Finance & Insurance",
    flow: "Lead Nurturing",
    subText: "Nurture every prospect. Build lasting trust.",
    stats: [
      {
        prefix: "",
        value: 30,
        suffix: "%",
        label: "More conversion",
      },
      {
        prefix: "",
        value: 28,
        suffix: "%",
        label: "Better renewal rates",
      },
      {
        prefix: "",
        value: 65,
        suffix: "%",
        label: "Faster doc collection",
      },
    ],
    problem:
      "Advisors and agents lose valuable time manually chasing documents, renewals, and unresponsive leads, reducing productivity and delaying revenue opportunities.",
    impacts: [
      {
        title: "More Conversions",
        value: "30%",
      },
      {
        title: "Better Renewal Rates",
        value: "28%",
      },
      {
        title: "Faster Doc. Collection",
        value: "65%",
      },
    ],
  },
  {
    id: 5,
    icon: restaurants,
    title: "Restaurants & F&B",
    flow: "Orders & Reservations",
    subText: "Serve every table. Delight every guest.",
    stats: [
      {
        prefix: "",
        value: 20,
        suffix: "%",
        label: "No show rate without reminders",
      },
      {
        prefix: "",
        value: 50,
        suffix: "%",
        label: "Fewer no shows",
      },
      {
        prefix: "",
        value:3,
        suffix: "x",
        label: "Increase in bookings",
      },
    ],
    problem:
      "Restaurants lose revenue and increase food waste when no-shows, missed reservations, and delayed customer engagement leave tables empty during peak hours.",
    impacts: [
      {
        title: "No Show Rate without Reminders",
        value: "20%",
      },
      {
        title: "Fewer No Shows",
        value: "50%",
      },
      {
        title: "Increase in Bookings",
        value: "3x",
      },
    ],
  },
   {
    id: 6,
    icon: retailStores,
    title: "Retail Stores",
    flow: "Offer Campaigns",
    subText: "Drive every visit. Boost every sale.",
    stats: [
      {
        prefix: "",
        value: 98,
        suffix: "%",
        label: "Message open rate",
      },
      {
        prefix: "",
        value: 53,
        suffix: "%",
        label: "Retailers already automate",
      },
      {
        prefix: "",
        value:50,
        suffix: "%",
        label: "Campaign click through",
      },
    ],
    problem:
      "Retail stores miss repeat sales by relying on walk-in customers instead of engaging existing customers through direct, personalized communication and automation.",
    impacts: [
      {
        title: "Message Open Rates",
        value: "98%",
      },
      {
        title: "Retailers Automated",
        value: "53%",
      },
      {
        title: "Campaign Click Through",
        value: "50%",
      },
    ],
  },
  {
    id: 7,
    icon: automobile,
    title: "Automobiles Dealers",
    flow: "Test-Drive Booking",
    subText: "Schedule every test drive. Convert every buyer.",
    stats: [
      {
        prefix: "",
        value: 2,
        suffix: "x",
        label: "More test drives",
      },
      {
        prefix: "",
        value: 35,
        suffix: "%",
        label: "Test drive conversions",
      },
      {
        prefix: "",
        value:4,
        suffix: "x",
        label: "Of reply rate of mail",
      },
    ],
    problem:
      "Automotive dealers lose qualified buyers when slow responses during critical decision moments result in missed appointments, lower conversions, and lost sales.",
    impacts: [
      {
        title: "More Test driver per week",
        value: "2x",
      },
      {
        title: "More Test Drive Conversions",
        value: "35%",
      },
      {
        title: "The Reply Rate of Email",
        value: "4x",
      },
    ],
  },
   {
    id: 8,
    icon: salon,
    title: "Salons & Spa",
    flow: "Booking Automation",
    subText: "Fill every slot. Retain every client.",
    stats: [
      {
        prefix: "<",
        value: 5,
        suffix: "%",
        label: "No show rate",
      },
      {
        prefix: "",
        value: 45,
        suffix: "%",
        label: "Hgher rebooking",
      },
      {
        prefix: "",
        value:35,
        suffix: "%",
        label: "Fewer cancellations",
      },
    ],
    problem:
      "Salons and spas lose revenue when appointment no-shows, missed reminders, and inefficient scheduling leave valuable service time unfilled and unrecoverable.",
    impacts: [
      {
        title: "No Show Rate",
        value: "<5%",
      },
      {
        title: "Higher Rebooking",
        value: "45%",
      },
      {
        title: "Fewer Cancellations",
        value: "35x",
      },
    ],
  },
  {
    id: 9,
    icon: event,
    title: "Events & Webinars",
    flow: "Registration Flows",
    subText: "Register every attendee. Maximize every turnout.",
    stats: [
      {
        prefix: "",
        value: 50,
        suffix: "%",
        label: "Avg attendance rate",
      },
      {
        prefix: "",
        value: 25,
        suffix: "%",
        label: "Hgher attendance",
      },
      {
        prefix: "",
        value:98,
        suffix: "%",
        label: "Message open rate",
      },
    ],
    problem:
      "Event organizers lose attendance and event ROI when inadequate reminders lead to no-shows despite significant investment in registrations and promotions.",
    impacts: [
      {
        title: "Average Attendance Rate",
        value: "50%",
      },
      {
        title: "Higher Attendance",
        value: "25%",
      },
      {
        title: "Message Open Rate",
        value: "98%",
      },
    ],
  },
   /*{
    id: 11,
    icon: agencies,
    title: "Agencies & Freelancers",
    flow: "Client Management",
    subText: "Manage every client. Deliver every project.",
    stats: [
      {
        prefix: "",
        value: 39,
        suffix: "%",
        label: "Higher conversion",
      },
      {
        prefix: "",
        value: 98,
        suffix: "%",
        label: "Message open rate",
      },
      {
        prefix: "",
        value:66,
        suffix: "%",
        label: "Go on to buy",
      },
    ],
    problem:
      "Agencies lose client trust and retention when inconsistent communication, delayed updates, and missed follow-ups undermine the quality of their services.",
    impacts: [
      {
        title: "Higher Conversion Rates",
        value: "39%",
      },
      {
        title: "Message Open Rate",
        value: "98%",
      },
      {
        title: "Go on Buy or Sign",
        value: "66%",
      },
    ],
  },
   {
    id: 12,
    icon: localService,
    title: "Local Services",
    flow: "Inquiry Automation",
    subText: "Respond instantly. Win every enquiry.",
    stats: [
      {
        prefix: "",
        value: 70,
        suffix: "%",
        label: "Intrest drop",
      },
      {
        prefix: "",
        value: 21,
        suffix: "x",
        label: "Likely conversion",
      },
      {
        prefix: "",
        value:98,
        suffix: "%",
        label: "Message open rate",
      },
    ],
    problem:
      "Home service businesses lose jobs when slow lead responses allow faster competitors to secure customers before they can make contact.",
    impacts: [
      {
        title: "Intrest Drop after 10 Mins",
        value: "70%",
      },
      {
        title: "More Likely to Convert",
        value: "21x",
      },
      {
        title: "Message Open Rate",
        value: "98%",
      },
    ],
  },*/
]

export const integrations = [
  { img: "/Images/erp-next-logo.svg", name: "ERPNext" },
  { img: "/Images/google-contact-logo.svg", name: "Google Contact" },
  { img: "/Images/pabbly-logo.svg", name: "Pabbly" },
  { img: "/Images/api-integration-logo.svg", name: "API Integration" },
  { img: "/Images/wordpress-logo.svg", name: "WordPress" },
  { img: "/Images/google-sheets-logo.svg", name: "Google Sheets" },
  { img: "/Images/woocommerce-logo.svg", name: "WooCommerce" },
  { img: "/Images/razorpay-logo.svg", name: "Razorpay" },
]